/* @flow */
import * as React from 'react';

import { OPTIONS } from 'phoneCalls/components/PhoneCallNoteForm.jsx';
import Row from 'components/Row.jsx';
import MediaObject from 'components/MediaObject.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import Heading from 'components/Heading.jsx';
import PhoneCallNoteModal from 'phoneCalls/components/PhoneCallNoteModal.jsx';
import Text from 'components/Text.jsx';
import Link from 'components/Link.jsx';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

import './styles/MessageItem.scss';

type Props = PhoneCallMessageItemNoteQuery;

class PhoneCallMessageItemNote extends React.Component<Props> {
  render() {
    const { phoneCall } = this.props;

    if (!phoneCall) {
      return null;
    }

    const { note, reasons } = phoneCall;

    if (!reasons) {
      // schema says reasons may be null
      return null;
    }

    // $FlowFixMe our schema says the elements of `reasons` array can be null
    const reasonsFormatted = reasons.map(reason => OPTIONS.get(reason));

    if (note || reasons.length) {
      return (
        <ModalTrigger modal={<PhoneCallNoteModal uuid={phoneCall.uuid} />}>
          <div className="MessageItemContent-note">
            <Row size="xsmall">
              <MediaObject center figure="left" gutter="xsmall">
                <Heading level="3" flush>
                  Notes
                </Heading>
                <Text color="eclipse" size="xsmall" italic>
                  Only you can see this
                </Text>
              </MediaObject>
            </Row>
            <Text color="thunder" size="small">
              {reasonsFormatted.length > 0 ? (
                <Text color="pitch" weight="semibold">
                  {reasonsFormatted.join(', ')}
                </Text>
              ) : null}
              {reasonsFormatted.length && note ? <br /> : null}
              {note}
            </Text>
          </div>
        </ModalTrigger>
      );
    } else {
      return (
        <ModalTrigger modal={<PhoneCallNoteModal uuid={phoneCall.uuid} />}>
          <Link className="MessageItem-phoneCallCTA">
            <Text size="small" align="center">
              Take notes
            </Text>
          </Link>
        </ModalTrigger>
      );
    }
  }
}

const PHONE_CALL_QUERY = gql`
  query PhoneCallMessageItemNote($uuid: String!) {
    phoneCall(uuid: $uuid) {
      uuid
      note
      reasons
    }
  }
`;

const withPhoneCall = graphql(PHONE_CALL_QUERY, {
  options: ({ uuid }) => ({ variables: { uuid } }),
  props: ({ data }) => data,
});

export { PhoneCallMessageItemNote };

export default compose(withPhoneCall)(PhoneCallMessageItemNote);
